import type { FC } from "react";
import React from "react";
import { useFlow } from "@edreamsodigeo/frontend-core";
import { Body, Flex, RawMoney } from "@edreamsodigeo/prisma-design-system";

import type { LightboxOfferSubscriptionSingleProps } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/contracts";
import { Space } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/LightboxOfferSubscriptions/Space";

export const LightboxOfferSubscriptionSingle: FC<
  LightboxOfferSubscriptionSingleProps
> = ({ offer, isActiveTab, text }) => {
  const flow = useFlow();
  const isMobile = flow === "mobile";
  const textColor = isMobile && !isActiveTab ? "neutral.70" : "primary.50";
  const isOfferVisible =
    !!offer && !!offer?.renewalPrice.currency && !!offer?.renewalPrice.amount;

  return (
    <>
      {isOfferVisible && (
        <>
          {!isMobile && <Body type={"small"}>{text.title}</Body>}
          <Body type={"small"} color={textColor}>
            <RawMoney currency={offer.renewalPrice.currency}>
              {offer.renewalPrice.amount}
            </RawMoney>
            <Space />/{text.duration}
          </Body>
          {isMobile && (
            <Flex flexDirection={"column"}>
              <Body type={"xxSmall"} color={"neutral.70"}>
                {text.freeTrial}
              </Body>
            </Flex>
          )}
        </>
      )}
    </>
  );
};
